/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM, createNamespace } from 'src/util/bem';
import './handleComplete.less';
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import { GridOptions } from 'ag-grid-community';
import NumberRender from 'src/components/agGridComponent/NumberRender';
import ECharts from 'vue-echarts';
import DataCompleteApi from './api/completLogApi';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import { CommonUtil } from 'src/util/commonUtil';
import MenuBtn from 'src/pages/layout/components/menuBtn';
import Button from 'src/types/iview/Button';
import { PublicApiI } from 'src/util/publicApi';
import CompleteLog from './completeLog';
import { Toast } from 'src/util/toast';
import RouteUtils from 'src/util/routeUtils';
let bem = createBEM('handle-complete');

export interface HandleCompletePropsI {
    value: string | number;
}

@Component({ name: 'data-manage-data-complete-handle' })
export default class HandleComplete extends Vue.Component<HandleCompletePropsI> {
    @Prop({
        type: [String, Number],
    })
    value!: string | number;

    // 附件相关的表格
    gridOptions: GridOptions = {};

    columnDefs: ColDefCustom[] = [
        {
            headerName: '时间',
            field: 'DateTime',
            minWidth: 140,
        },
    ];

    rowData: any[] = [];
    components: ReadonlyArray<PublicApiI.DivisorI> = [];
    index = 0;
    loading: boolean = false
    longDistanceLoading: boolean = false

    get option() {
        let t = this;
        t.index;
        let series: any[] = [];
        series = this.components.map(i => {
            return {
                name: i.name,
                type: 'line',
                smooth: true,
                lineStyle: { width: 3 },
                data: this.rowData.map(row => ({
                    name: DateTimeUtil.formateDate(row.timestamp * 1000),
                    value: [DateTimeUtil.formateDate(row.timestamp * 1000), row[i.key + '-Rtd']],
                })),
            };
        });
        return {
            color: ['#f45904', '#02fb71', '#419fff', '#effb29', '#00c9db', '#facd89', '#f19ec2', '#9eadf7', '#e4007f', '#ff00ff'],
            title: {
                text: '',
                textStyle: {
                    fontSize: 22,
                    color: '#fff',
                },
                left: 20,
                top: 15,
            },
            tooltip: {
                trigger: 'axis',
                formatter(params) {
                    return [`<span>${params[0].data.name}</span>`,...params
                        .map(i => {
                            let unit = t.components.find(divisor => {
                                return i.seriesName === divisor.name;
                            })!.unit;
                            return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                                i.color
                            };"></span>${i.seriesName}：${i.value[1]}${unit}`;
                        })]
                        .join('<br/>');
                },
            },
            legend: {
                data: this.components.map(i => i.name),
                textStyle: {
                    fontSize: 16,
                    color: '#fff',
                },
                top: 15,
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '20',
                containLabel: true,
            },
            xAxis: {
                type: 'time',
                boundaryGap: false,
                axisLabel: {
                    color: '#C3EBFF',
                    fontSize: 16,
                },
                axisLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                    },
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                        opacity: 0.2,
                    },
                },
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    color: '#02FB71',
                    fontSize: 16,
                },
                axisLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: '#1DA4FF',
                        width: 3,
                        opacity: 0.2,
                    },
                },
            },
            series: series,
        };
    }
    async init() {
        let t = this;
        let { code, data } = await DataCompleteApi.searchDataDetail({
            mn: this.$route.query.mn,
            start_time: DateTimeUtil.getSecondFromIviewDate(this.$route.query.date, 'start')!,
            end_time: DateTimeUtil.getSecondFromIviewDate(this.$route.query.date, 'end')!,
        });
        if (code === 0) {
            this.components = data.header;
            this.columnDefs = [
                ...this.columnDefs,
                ...data.header.map(i => {
                    let field = `${i.key}-Rtd`;
                    return {
                        headerName: `${i.name}(${i.unit})`,
                        field,
                        minWidth: 120,
                        cellRendererFramework: NumberRender,
                        cellRendererFrameworkOpt: {
                            editable: params => params.data[`${i.key}-edit`],
                            precision: 2,
                        },
                    };
                }),
            ];
            data.body.forEach(i => {
                data.header.forEach(j => {
                    let field = `${j.key}-Rtd`;
                    if (CommonUtil.isFieldEmpty(i[field])) {
                        i[field] = null;
                        i[`${j.key}-edit`] = true;
                    } else {
                        i[field] = +i[field];
                        i[`${j.key}-edit`] = false;
                    }
                });
            });
            this.rowData = data.body;
        }
    }

    async mounted() {
        this.init()
    }
    async longDistance() {
        this.longDistanceLoading = true
        let { code } = await DataCompleteApi.longDistance({
            mn: this.$route.query.mn,
            begintime: DateTimeUtil.getSecondFromIviewDate(this.$route.query.date, 'start')!,
            endtime: DateTimeUtil.getSecondFromIviewDate(this.$route.query.date, 'end')!,
        });
        this.longDistanceLoading = false
        if (code === 0) {
            Toast.success('远程补遗成功！')
            this.init()
        }
    }
    async save() {
        let dataInfo = this.rowData.map(i=> {
            let obj:any = {id: i.id, timestamp: i.timestamp}
            this.components.forEach(com=> {
                if(i[com.key+'-edit']) {
                    obj[com.key+'-Rtd'] = i[com.key+'-Rtd']
                }
            })
            return obj
        })
        this.loading = true
        let { code } = await DataCompleteApi.handleComplete({
            mn: this.$route.query.mn,
            device_name: this.$route.query.name,
            data_info: dataInfo,
        });
        this.loading = false
        if(code === 0) {
            Toast.success('补遗成功！')
        }
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>
                    <span class={createNamespace('mr20')}>站点名称：{this.$route.query.name}</span>
                    <span class={createNamespace('mr20')}>日期：{DateTimeUtil.formateDate(this.$route.query.date, 'YYYY-MM-DD')}</span>
                    <span class={createNamespace('mr20')}>
                        数据完整率：{this.$route.query.rate}
                    </span>
                    <Button type="primary" class={createNamespace('mr20')} onClick={this.save.bind(this)} loading={this.loading}>
                        保存
                    </Button>
                    <Button type="primary" class={createNamespace('mr20')} onClick={this.longDistance.bind(this)} loading={this.longDistanceLoading}>
                        远程一键补遗
                    </Button>
                    <div class={bem('back')} onClick={()=> RouteUtils.goBack()}>返回</div>
                </div>
                <div class={bem('table')}>
                    <AgGridVueCustomTsx
                        ref="ag"
                        gridOptions={this.gridOptions}
                        columnDefs={this.columnDefs}
                        rowData={this.rowData}
                        enableServerSideSorting={false}
                        checkBoxShow={false}
                        pageShow={false}
                    />
                </div>
                <div class={[bem('chart'), 'ag-theme-material', createNamespace('mt10 mb10')]}>
                    <ECharts style="height:100%;width:100%" options={this.option} auto-resize={true} />
                </div>
            </div>
        );
    }
}
